import React, { useEffect, useState } from "react";
import "./ClientPaymentDetails.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    getClientPayments,
    getMonthlyClientPayments,
    getDateRangeClientPayments
} from "../../../services/payment/api";

const ClientPaymentDetails = () => {

    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(0);
    const [size] = useState(10);

    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const [showFilter, setShowFilter] = useState(false);
    const [isFilterApplied, setIsFilterApplied] = useState(false);

    const [filterType, setFilterType] = useState("month");

    const [selectedMonth, setSelectedMonth] = useState("");

    const [startDate, setStartDate] = useState("");

    const [endDate, setEndDate] = useState("");

    useEffect(() => {

        fetchPayments();

    }, [page]);

    const fetchPayments = async () => {

        try {

            setLoading(true);

            let response;

            if (isFilterApplied) {

                if (filterType === "month") {

                    const [year, month] = selectedMonth.split("-");

                    response = await getMonthlyClientPayments(
                        Number(month),
                        Number(year),
                        page,
                        size
                    );

                } else {

                    response = await getDateRangeClientPayments(
                        startDate,
                        endDate,
                        page,
                        size
                    );

                }

            } else {

                response = await getClientPayments(
                    page,
                    size
                );

            }

            const pageData = response.data.data;

            setPayments(pageData.content);
            setTotalPages(pageData.totalPages);
            setTotalElements(pageData.totalElements);

        } catch (error) {

            console.error("Error fetching client payments:", error);
            toast.error("Failed to load client payments.");

        } finally {

            setLoading(false);

        }

    };

    const applyFilter = async () => {

        try {

            if (filterType === "month") {

                if (!selectedMonth) {

                    toast.warning("Please select a month");

                    return;

                }

            }

            if (filterType === "date") {

                if (!startDate || !endDate) {

                    toast.warning("Please select start date and end date");

                    return;

                }

                if (new Date(startDate) > new Date(endDate)) {

                    toast.error("Start Date cannot be greater than End Date");

                    return;

                }

            }

            setIsFilterApplied(true);

            setPage(0);

            setShowFilter(false);

            let response;

            if (filterType === "month") {

                const [year, month] = selectedMonth.split("-");

                response = await getMonthlyClientPayments(
                    Number(month),
                    Number(year),
                    0,
                    size
                );

            } else {

                response = await getDateRangeClientPayments(
                    startDate,
                    endDate,
                    0,
                    size
                );

            }

            const pageData = response.data.data;

            setPayments(pageData.content);
            setTotalPages(pageData.totalPages);
            setTotalElements(pageData.totalElements);

        } catch (error) {

            console.error(error);
            toast.error("Something went wrong");

        }

    };

    const resetFilter = async () => {

        try {

            setSelectedMonth("");

            setStartDate("");

            setEndDate("");

            setFilterType("month");

            setIsFilterApplied(false);

            setPage(0);

            setShowFilter(false);

            const response = await getClientPayments(
                0,
                size
            );

            const pageData = response.data.data;

            setPayments(pageData.content);
            setTotalPages(pageData.totalPages);
            setTotalElements(pageData.totalElements);

        } catch (error) {

            console.error(error);
            toast.error("Failed to reset filters.");

        }

    };

    return (

        <div className="client-payment-container">

            <div className="payment-header">

                <h2 className="client-payment-title">

                    Client Payment Details

                </h2>

                <button
                    className="filter-btn"
                    onClick={() => setShowFilter(!showFilter)}
                >
                    📅 Filter
                </button>

            </div>

            {

                showFilter &&
                (
    <div className="filter-popup">

        <h4>Filter Payments</h4>

        <div className="filter-field">

            <label>Filter Type</label>

            <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
            >
                <option value="month">Monthly</option>
                <option value="date">Date Range</option>
            </select>

        </div>

        {

            filterType === "month" && (

                <div className="filter-field">

                    <label>Select Month</label>

                    <input
                        type="month"
                        value={selectedMonth}
                        onChange={(e) =>
                            setSelectedMonth(e.target.value)
                        }
                    />

                </div>

            )

        }

        {

            filterType === "date" && (

                <>

                    <div className="filter-field">

                        <label>Start Date</label>

                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) =>
                                setStartDate(e.target.value)
                            }
                        />

                    </div>

                    <div className="filter-field">

                        <label>End Date</label>

                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) =>
                                setEndDate(e.target.value)
                            }
                        />

                    </div>

                </>

            )

        }

        <div className="filter-buttons">

            <button
                className="apply-btn"
                onClick={applyFilter}
            >
                Apply
            </button>

            <button
                className="reset-btn"
                onClick={resetFilter}
            >
                Reset
            </button>

        </div>

    </div>

)

}

{

    loading ?

        <div className="loading">

            Loading Client Payments...

        </div>

        :

        <>

            <table className="client-payment-table">

                <thead>

                    <tr>

                        <th>S.No</th>

                        <th>Client Name</th>

                        <th>Email</th>

                        <th>Contact Number</th>

                        <th>Recharge Amount</th>

                        <th>Payment Date</th>

                    </tr>

                </thead>

                <tbody>

                {

                    payments.length > 0 ?

                        payments.map((payment, index) => (

                            <tr key={index}>

                                <td>

                                    {page * size + index + 1}

                                </td>

                                <td>

                                    {payment.clientName}

                                </td>

                                <td>

                                    {payment.email}

                                </td>

                                <td>

                                    {payment.contactNumber || "-"}

                                </td>

                                <td>

                                    ₹ {payment.rechargeAmount}

                                </td>

                                <td>

                                    {payment.paymentDate}

                                </td>

                            </tr>

                        ))

                        :

                        <tr>

                            <td
                                colSpan="6"
                                className="no-data"
                            >

                                No Client Payments Found

                            </td>

                        </tr>

                }

                </tbody>

            </table>

            {

                totalPages > 1 &&
                (
    <div className="pagination-container">

        <div className="pagination-summary">

            {
                payments.length === 0 ? (
                    <>Showing 0 to 0 of 0 entries</>
                ) : (
                    <>
                        Showing {page * size + 1} to{" "}
                        {page * size + payments.length} of{" "}
                        {totalElements} entries
                    </>
                )
            }

        </div>

        <div className="pagination-right">

            <button
                className="pagination-nav"
                onClick={() => setPage(page - 1)}
                disabled={page === 0}
            >
                Previous
            </button>

            <div className="pagination-pages">

                {Array.from(
                    { length: totalPages },
                    (_, index) => (

                        <button
                            key={index}
                            className={`page-number ${
                                page === index
                                    ? "active-page"
                                    : ""
                            }`}
                            onClick={() => setPage(index)}
                        >
                            {index + 1}
                        </button>

                    )
                )}

            </div>

            <button
                className="pagination-nav"
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages - 1}
            >
                Next
            </button>

        </div>

    </div>
)

}

        </>

}

        </div>

    );

};

export default ClientPaymentDetails;